import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import storage from "redux-persist/lib/storage";
import { ManageUserAppState } from "../appState/models";
import { CreateUserDetail } from "./models";
import { ConsolidatedReport, UserRoleListType } from "../../../api/services/manageUser/models";

const initialState: ManageUserAppState = {
  createUserDetail: {} as CreateUserDetail,
  userRoleList: [],
  addedReports: [],
};

const manageUserSlice = createSlice({
  name: "manageUserSlice",
  initialState,
  reducers: {
    setCreateUserDetail: (
      state,
      { payload }: PayloadAction<CreateUserDetail>,
    ) => {
      state.createUserDetail = payload;
    },
    setCreateUserHomeOfficeDetail: (
      state,
      { payload }: PayloadAction<string>,
    ) => {
      state.createUserDetail.homeOfficeText = payload;
    },
    setUserRoleList: (
      state,
      { payload }: PayloadAction<UserRoleListType[]>,
    ) => {
      state.userRoleList = payload;
    },
    storeAddedReportsFromEditData: (
      state,
      { payload }: PayloadAction<ConsolidatedReport[]>,
    ) => {
      state.addedReports = payload;
    },
  },
});

export const {
  setCreateUserDetail,
  setUserRoleList,
  storeAddedReportsFromEditData,
  setCreateUserHomeOfficeDetail,
} = manageUserSlice.actions;

export const persistManageUserConfig = {
  version: 1,
  key: "mpg_next_admin_program_v1",
  storage,
  whitelist: [],
};

export default manageUserSlice.reducer;
